import { Reveal, MaskLineInView } from "../Reveal";
import { useLanguage } from "../../i18n/LanguageContext";

export const HowWeWork = () => {
  const { t } = useLanguage();
  return (
    <section id="process" data-testid="how-we-work-section" className="py-24 md:py-36 bg-forest text-cream">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <h2 className="font-display text-5xl md:text-7xl tracking-tight mb-20 text-cream">
          <MaskLineInView>{t.process.heading[0]}</MaskLineInView>
          <MaskLineInView delay={0.1} className="text-gold">{t.process.heading[1]}</MaskLineInView>
        </h2>

        <div className="divide-y divide-cream/20 border-t border-cream/20">
          {t.process.steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="relative grid md:grid-cols-12 gap-6 md:gap-10 py-12 group transition-transform duration-500 ease-out md:hover:translate-x-3">
                {/* A gold rule draws itself across the row on hover, so the list
                    stays quiet until you actually point at a step. */}
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-gold transition-transform duration-700 ease-out group-hover:scale-x-100"
                />
                <div className="md:col-span-4">
                  <span className="inline-block origin-left font-display text-7xl md:text-8xl text-cream/20 transition-all duration-500 group-hover:scale-110 group-hover:text-gold">
                    0{i + 1}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display text-3xl md:text-4xl text-cream">{s.title}</h3>
                </div>
                <div className="md:col-span-4">
                  <p className="text-cream/70 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
